export type FormatCurrencyOptions = Intl.NumberFormatOptions & { locale?: string };

const defaultOptions: FormatCurrencyOptions = {
    style: 'currency',
    currency: 'AUD',
    locale: 'en-AU',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
};
export function formatCurrency(amount: number, options: FormatCurrencyOptions = defaultOptions) {
    const { locale, ...userOptions } = options;

    return new Intl.NumberFormat(locale || defaultOptions.locale, {
        ...defaultOptions,
        ...userOptions,
    }).format(amount);
}
